import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {labels, AdministerEngagementUserRoleId} from '../../util/uiconstants';
import {engagementUserStatus} from '../../util/enumerations';
import env from '../../util/env';
import ModalControl from '@ey/modal-control';
import EllipsesControl from '@ey/ellipses-control';
import {useDispatch, useSelector} from 'react-redux';
import {PatchEngagement} from '../../actions/engagementsaction';
import {adobeAnalytics} from '@ey/voltron-analytics';
import {clickActionArgs} from '../Common/Adobe Analytics/actionHelpers.js';
import {
	eventTypes,
	controlTypes,
	clickActionNames,
	locationInPages
} from '../Common/Adobe Analytics/constants.js';
import {getUserEngagementPermissions} from '../../actions/usersettingsaction';
import Loader from '../Common/Loaders/loadingindicator';

const EngagementRemoveModal = (props) => {
	const dispatch = useDispatch();

	const {show, quit, hide, id} = props;
	const {engagementdesc, engagementstatus, workspacecountryid} = props.data;

	const userSettings = useSelector((state) => state.userSettings);
	const userPermissions = useSelector((state) => state.userPermissions);

	const [isLoading, setIsLoading] = useState(true);
	const [showConfirm, setShowConfirm] = useState(false);

	const cancelRemoveMsg = labels.removeengagementerrormessage;
	const canRemoveMsg = labels.removeengaementconfirmationmessage1;
	const trackEvent = adobeAnalytics.useAdobeAnalyticsTrack();

	useEffect(() => {
		const getEngagementUserPermissions = async () => {
			try {
				await dispatch(
					getUserEngagementPermissions(userSettings?.data?.id, id)
				).then(() => {
					setIsLoading(false);
				});
			} catch (e) {
				setIsLoading(false);
			}
		};
		if (show) {
			setIsLoading(true);
			getEngagementUserPermissions();
		}
	}, [show]);

	useEffect(() => {
		if (!userPermissions || !show) {
			setShowConfirm(false);
			return;
		}

		// Extract all the necessary conditions from user permissions
		const isAdmin = userPermissions?.userRoles?.some(
			(role) => role?.roleId === AdministerEngagementUserRoleId
		);
		const hasOtherRolesThanAdmin =
			(
				userPermissions?.userRoles?.filter(
					(role) => role?.roleId !== AdministerEngagementUserRoleId
				) || []
			).length > 0;
		const adminCount = userPermissions?.engagementAdminUsersCount || 0;

		const canShowConfirmation =
			(isAdmin && adminCount > 1) || // Admin with other admins present
			(!isAdmin && hasOtherRolesThanAdmin) || // Non-admin with multiple roles
			(!isAdmin && !hasOtherRolesThanAdmin && adminCount > 0); // Non-admin with single role but admins exist

		setShowConfirm(canShowConfirmation);
	}, [userPermissions]);

	const handleRemoveConfirm = async () => {
		// Adobe Analytics Click Tracking
		trackEvent(
			eventTypes.clickAction,
			clickActionArgs(
				clickActionNames.removeEngagementConfirm,
				controlTypes.button,
				locationInPages.removeEngagementModal
			)
		);

		try {
			await dispatch(
				PatchEngagement(
					env.getURL('serviceUrl') + '/' + 'EngagementUsers.json',
					JSON.stringify(modelRemove())
				)
			);
			hide();
		} catch (e) {
			quit();
		}
	};

	const modelRemove = () => {
		const payload = {
			id: id,
			engagementUserStatusId: engagementUserStatus.DeActivated,
			engagementstatusid: engagementstatus
		};

		return {
			collections: {
				teammembers: [],
				engagements: [
					{
						data: payload,
						id: id
					}
				]
			},
			data: {
				countryid: workspacecountryid,
				operationType: 'removeengagementfromworkspace'
			}
		};
	};

	const onHide = () => {
		// Adobe Analytics Click Tracking
		trackEvent(
			eventTypes.clickAction,
			clickActionArgs(
				clickActionNames.removeEngagementCancel,
				controlTypes.button,
				locationInPages.removeEngagementModal
			)
		);
		quit();
	};

	return (
		<ModalControl
			title={labels.removeengagementquestionlabel}
			closeTitle={labels.close}
			confirmBtnTitle={labels.confirm}
			closeBtnTitle={labels.cancel}
			modalsize="small"
			onOkClick={handleRemoveConfirm}
			show={show}
			onHide={onHide}
			isOkButtonDisabled={!showConfirm}
			focusTrapActive={false}
		>
			{isLoading ? (
				<Loader show view="blockView" styleName="loadingstyle" />
			) : (
				<RemoveEngagementStyle>
					<div id="message">
						<h6>{!showConfirm ? cancelRemoveMsg : canRemoveMsg}</h6>
					</div>
					<h6 className="engagement-name">
						<EllipsesControl
							id=""
							content={engagementdesc}
							tooltip={engagementdesc}
							isTooltipAvailable
						/>
					</h6>
				</RemoveEngagementStyle>
			)}
		</ModalControl>
	);
};
export default EngagementRemoveModal;

const RemoveEngagementStyle = styled.section`
	h6 {
		font-size: var(--px-14);
		line-height: normal;
		word-break: break-word;
		margin: var(--px-20);
	}

	& .engagement-name {
		width: calc(100% - var(--px-40));
		padding: 0;
		display: inline-block;
		margin: 0 var(--px-20) var(--px-20) var(--px-20);
		& .ellipses {
			font-weight: bold;
		}
	}
`;
